module.exports = __webpack_public_path__ + "images/icon-instagram.c949e4d95db90ac8c84e.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icon-instagram.svg
// module id = TJsH
// module chunks = 24